<script setup lang="ts">
const props = defineProps<{
	numChanges: number
	canSave: boolean
	isSaving: boolean
}>()
// to-do: use a generic toolbar instead
const emit = defineEmits(['save', 'reset'])
</script>

<template>
	<div v-if="true" class="container fixed-bottom mb-4">
		<div class="row justify-content-center">
			<div class="col-auto text-center">
				<div class="d-inline-flex justify-content-between toolbar text-nowrap">
					<button
						data-test="cancel-threat"
						class="btn btn-close me-3 mt-2"
						@click="emit('reset')"
						:aria-label="$t('misc.cancel')"
						role="button"
					></button>
					<button
						id="save-threat"
						class="btn btn-primary"
						:disabled="!props.canSave || props.isSaving"
						@click="emit('save')"
						:aria-label="$t('misc.save')"
						role="button"
					>
						<i class="bi bi-floppy"></i>
						{{ $t('misc.save') }}: {{ props.numChanges }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
